import React from 'react';

const Hero: React.FC = () => {
  return (
    <section id="home" className="hero">
      <div className="container hero-content">
        <h1 className="hero-title">
          Apps for learning
          <span className="accent">and everyday life</span>
        </h1>
        <p className="hero-subtitle">
          Spiegelei Studio is an independent software studio in Cologne, Germany. We build mobile
          apps and browser extensions for learning languages, chess, and travel. Our products are
          digital: the apps are free to download, and some offer an optional Premium subscription.
        </p>
        <div className="hero-actions">
          <a href="#apps" className="btn btn-primary">Our apps</a>
          <a href="#billing" className="btn btn-secondary">Pricing &amp; billing</a>
        </div>
      </div>
    </section>
  );
};

export default Hero;
